import NonImpedimentModule from '@features/Consular/components/non-impediment/NonImpediment.Module';
import React from 'react';

const NonImpediment = () => {
  return <NonImpedimentModule />;
};

export default NonImpediment;
